export enum Position {

    PARTY_MEMBER = 1,
    ACTIVIST = 2

}
